export const CERTIFICATE_LANGUAGES = {
  pl: 'pl',
  en: 'en',
  de: 'de',
} as const;
